import { useSettings } from "../../context";
import TextSettings from "./text-settings";
import VideoSettings from "./video-settings";

const Configuration = () => {
  const { getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  switch (currentSettings?.type) {
    case "text":
      return <TextSettings />;
    case "video":
      return <VideoSettings />;
    default:
      return <div>Default Settings</div>;
  }
};

export default Configuration;
